import { render, staticRenderFns } from "./WorkrolesList.vue?vue&type=template&id=793c79a0&"
import script from "./WorkrolesList.vue?vue&type=script&lang=js&"
export * from "./WorkrolesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports